import React, { useState } from 'react';
import api from '../services/api';
import './VerifyDocument.css';

function VerifyDocument() {
    const [refCode, setRefCode] = useState('');
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleVerify = async (e) => {
        e.preventDefault();

        if (!refCode.trim()) {
            setError('กรุณาระบุรหัสอ้างอิง');
            return;
        }

        setLoading(true);
        setError('');
        setResult(null);

        try {
            const response = await api.post('/report/verify-document', { refCode: refCode.trim().toUpperCase() });
            setResult(response.data);
        } catch (err) {
            setError(err.response?.data?.error || 'เกิดข้อผิดพลาดในการตรวจสอบ');
        } finally {
            setLoading(false);
        }
    };

    const formatNumber = (num) => {
        if (!num) return '0.00';
        return Number(num).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const thaiMonths = [
        '', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    return (
        <div className="verify-document-page">
            <div className="verify-container">
                <div className="verify-header">
                    <img src="/logo192.png" alt="Logo" className="verify-logo" />
                    <h1>ตรวจสอบเอกสาร</h1>
                    <p className="verify-subtitle">โรงพยาบาลศรีสะเกษ</p>
                </div>

                <form onSubmit={handleVerify} className="verify-form">
                    <div className="input-group">
                        <label htmlFor="refCode">รหัสอ้างอิงเอกสาร</label>
                        <input
                            type="text"
                            id="refCode"
                            value={refCode}
                            onChange={(e) => setRefCode(e.target.value.toUpperCase())}
                            placeholder="เช่น SLIP-2568-12-1234567890-A3B5"
                            className="ref-input"
                            autoComplete="off"
                        />
                        <small className="input-hint">
                            รหัสอ้างอิงอยู่ด้านล่างของเอกสาร
                        </small>
                    </div>

                    <button type="submit" className="verify-btn" disabled={loading}>
                        {loading ? 'กำลังตรวจสอบ...' : 'ตรวจสอบเอกสาร'}
                    </button>
                </form>

                {error && (
                    <div className="verify-error">
                        <i className="fas fa-exclamation-circle"></i>
                        {error}
                    </div>
                )}

                {result && (
                    <div className={`verify-result ${result.valid ? 'valid' : 'invalid'}`}>
                        <div className="result-icon">
                            {result.valid ? (
                                <i className="fas fa-check-circle"></i>
                            ) : (
                                <i className="fas fa-times-circle"></i>
                            )}
                        </div>

                        <div className="result-status">
                            {result.valid ? 'เอกสารถูกต้อง' : 'เอกสารไม่ถูกต้อง'}
                        </div>

                        <div className="result-message">
                            {result.message}
                        </div>

                        {result.valid && (
                            <div className="result-details">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>ประเภทเอกสาร:</td>
                                            <td>
                                                {result.docType === 'SLIP' ? 'สลิปเงินเดือน' : 'หนังสือรับรองการหักภาษี ณ ที่จ่าย (50 ทวิ)'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>ชื่อพนักงาน:</td>
                                            <td>{result.employeeName}</td>
                                        </tr>
                                        {result.docType === 'SLIP' && (
                                            <>
                                                <tr>
                                                    <td>เดือน/ปี:</td>
                                                    <td>{thaiMonths[result.month]} {result.year}</td>
                                                </tr>
                                                <tr>
                                                    <td>เงินเดือนสุทธิ:</td>
                                                    <td>{formatNumber(result.netAmount)} บาท</td>
                                                </tr>
                                            </>
                                        )}
                                        {result.docType === 'TAWI' && (
                                            <>
                                                <tr>
                                                    <td>ปีภาษี:</td>
                                                    <td>{result.year}</td>
                                                </tr>
                                                <tr>
                                                    <td>รายได้รวม:</td>
                                                    <td>{formatNumber(result.totalIncome)} บาท</td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}

                <div className="verify-footer">
                    <p>หากมีข้อสงสัย กรุณาติดต่อฝ่ายการเงิน โรงพยาบาลศรีสะเกษ</p>
                    <p>โทร. 045-617-xxx</p>
                </div>
            </div>
        </div>
    );
}

export default VerifyDocument;
